import { useContext, useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import "./create-dashboard.sass";
import Select from "react-select";
import { useStore } from "../../hooks-store/store";
import { getReportingLinks } from "../../pages/reporting/links";
import { sendCallToAPI } from "../../common/generic_functions";
import { ReportingContext } from "../../pages/home/home";
import { DebouncedInput } from "../debounce-input/debounce-input";
import { LoadingScreen } from "../loadingspinner/loading-screen";
import { PERMISSIONS } from "../../common/constants";
import { Can } from "../permission/can";
import { AlertContext } from "../../pages/login/login";

export const CreateDashboard = () => {
  const [createDashboard, setCreateDashboard] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
  const { getWorkSpacePermissions } = useContext(ReportingContext);

   const hoverStyle = {
    backgroundColor: isHovering ? "#3E66FB": "transparent",
    color:  isHovering ? "white": "#3E66FB",
    border: "1px solid #3E66FB"
  };

  return (
    <div>
      <Can userRoles={getWorkSpacePermissions()} requiredRoles={[PERMISSIONS["ADD_REPORT"]]}>
      <Button 
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      style={hoverStyle} onClick={() => setCreateDashboard(!createDashboard)}>
       Add Report
      </Button>
      </Can>
      {createDashboard && <CreateDashboardModal handleclose={() => setCreateDashboard(false)} />}
    </div>
  );
};

const CreateDashboardModal = ({ handleclose }) => {
  const [store] = useStore();
  const [loading, setLoading] = useState(false);

  const saveData = async (payload, link) => {
    setLoading(true);
    const response = await sendCallToAPI(link, store.accessToken, payload, "POST");
    setLoading(false);
    window.location.reload();
  };

  return (
    <Modal show={true} onHide={handleclose} className="reporting-create-dashboard" backdrop="static" keyboard={false} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{`Create Report`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoadingScreen loading={loading} />
        <DashboardStepper saveData={(payload, link) => saveData(payload, link)} />
      </Modal.Body>
    </Modal>
  );
};

const MAXSTEP = 3;

const DashboardStepper = ({ saveData }) => {
  const [step, setStep] = useState(+1);
  const { getCurrentWorkSpace } = useContext(ReportingContext);
  const [errors, setErrors] = useState({});
  const { enableAlert } = useContext(AlertContext)

  const [dataObject, setDataObject] = useState({
    template: null,
    reportType: "campaign_digital",
    hiddenTabs: [],
    selectedCampaigns: [],
    name: "",
    description: "",
  });

  const changeStep = (newStep) => {
    let tempErr = {};
    switch (newStep) {
      case +0:
        setDataObject((v) => ({ ...v, template: "" }));
        Object.keys(errors).forEach((f) => {
          if (!["templates"].includes(f)) {
            tempErr[f] = errors[f];
          }
        });
        break;
      case 1:
        setDataObject((v) => ({ ...v, hiddenTabs: [] }));
        Object.keys(errors).forEach((f) => {
          if (!["hiddenTabs"].includes(f)) {
            tempErr[f] = errors[f];
          }
        });
        break;
      case 2:
        setDataObject((v) => ({ ...v, selectedCampaigns: [], name: "", description: "" }));
        Object.keys(errors).forEach((f) => {
          if (!["name", "description", "selectedCampaigns"].includes(f)) {
            tempErr[f] = errors[f];
          }
        });

        break;
      default:
        break;
    }
    setErrors(tempErr);
    setStep(newStep);
  };

  const changeDataObject = (newObj) => {
    let temp =  JSON.parse(JSON.stringify(newObj));
    setDataObject(temp);
  };

  const anyError = () => {
    let result = {};
    const requiredFields = ["template", "name", "description"];
    requiredFields.forEach((f) => {
      if (!dataObject[f] || !dataObject[f].trim()) {
        result[f] = "Field is required!";
      }
    });
    if (dataObject.selectedCampaigns.length === +0) {
      result["selectedCampaigns"] = "Field is required!";
    }
    setErrors(result);
    return Object.keys(result).length !== +0;
  };

  const addReport = async () => {
    if (anyError()) {
      enableAlert({ type: "danger", text: "Something went wrong. Try again later" });
      return;
    }
    const payload = {
      target_workspace_id: getCurrentWorkSpace(),
      target_report_name: dataObject.name,
      target_report_description: dataObject.description,
      target_report_type: dataObject.reportType,
      hidden_tabs: dataObject.hiddenTabs,
      digital_campaign_ids: dataObject.selectedCampaigns.join(","),
    };
    const link = `${getReportingLinks("addReport")}${dataObject.template}/`;
    saveData(payload, link);
  };

  return (
    <div className="wrapper">
      <SteppHeader step={step} maxStep={MAXSTEP} />
      <SteppBody step={step} dataObject={dataObject} changeDataObject={(newObj) => changeDataObject(newObj)} errors={errors} />
      <SteppFooter step={step} setStep={(v) => changeStep(v)} maxStep={MAXSTEP} addReport={() => addReport()} dataObject={dataObject}/>
    </div>
  );
};

const SteppHeader = ({ step, maxStep }) => {
  const createHeader = () => {
    let res = [];
    for (let i = 0; i <= maxStep; i++) {
      const checked = step >= i;
      res.push(
        <div className={`circle-number ${checked ? "number-checked" : ""}`} key={i + "circleNumber"}>
          {i + 1}
        </div>
      );
      if (i < maxStep) {
        res.push(<div className={`line ${checked ? "line-checked" : ""}`} key={i + "line"}></div>);
      }
    }
    return res;
  };
  return <div className="stepp-header">{createHeader()}</div>;
};

const SteppBody = ({ step, dataObject, changeDataObject, errors }) => {

  return (
    <div className="content">
      <SteppBodyItemWrapper show={step >= +0}>
        <ChooseReportType dataObject={dataObject} changeDataObject={changeDataObject} disabled={step !== +0} errors={errors} />
      </SteppBodyItemWrapper>
      <SteppBodyItemWrapper show={step >= 1}>
        <ChooseTemplate dataObject={dataObject} changeDataObject={changeDataObject} disabled={step !== +1} errors={errors} />
      </SteppBodyItemWrapper>
      <SteppBodyItemWrapper show={step >= 2}>
        <ChooseTabs dataObject={dataObject} changeDataObject={changeDataObject} disabled={step !== +2} errors={errors} />
      </SteppBodyItemWrapper>
      <SteppBodyItemWrapper show={step >= 3}>
        <ChooseCampaigns dataObject={dataObject} changeDataObject={changeDataObject} disabled={step !== +3} errors={errors} />
      </SteppBodyItemWrapper>
    </div>
  );
};

const SteppBodyItemWrapper = ({ show, children }) => {
  if (!show) {
    return <></>;
  }
  return children;
};

export const ChooseCampaigns = ({ dataObject, changeDataObject, errors }) => {
  const { getCurrentWorkSpace } = useContext(ReportingContext);
  const [store] = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const loadOptions = async () => {
    let currentWorkspace = getCurrentWorkSpace();
    const link = `${getReportingLinks("getCampaigns")}${currentWorkspace}/`;
    let resultCampaigns = await sendCallToAPI(link, store.accessToken);
    if (!resultCampaigns || !Array.isArray(resultCampaigns)) {
      resultCampaigns = [];
    }
    setOptions(resultCampaigns);
    setIsLoading(false);
  };

  useEffect(() => {
    loadOptions();
  }, []);

  const onChangeName = (value) => {
    dataObject["name"] = value;
    changeDataObject(dataObject);
  };

  const onChangeDescription = (value) => {
    dataObject["description"] = value;
    changeDataObject(dataObject);
  };
  const changeOption = (a, b) => {
    dataObject["selectedCampaigns"] = a.map((x) => x.value);
    changeDataObject(dataObject);
  };
  return (
    <div className="content-block">
      <div className="content-item">
        <label>Choose Campaigns:</label>
        <Select isMulti isLoading={isLoading} options={options} onChange={(a, b) => changeOption(a, b)} />
        <ErrorField value={"selectedCampaigns"} errors={errors} />
      </div>
      <div className="content-item">
        <label>Name:</label>
        <div>
          <DebouncedInput onChange={(v) => onChangeName(v)} />
          <ErrorField value={"name"} errors={errors} />
        </div>
      </div>
      <div className="content-item">
        <label>Description:</label>
        <textarea rows={3} onChange={(e) => onChangeDescription(e.target.value)}></textarea>
        <ErrorField value={"description"} errors={errors} />
      </div>
    </div>
  );
};
const ChooseTabs = ({ dataObject, changeDataObject, disabled, errors }) => {
  const [store] = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const [value, setValue] = useState([]);
  const [options, setOptions] = useState([]);
  const optionsSet = useRef(new Set());
  const loadOptions = async () => {
    const { template } = dataObject;
    const link = `${getReportingLinks("getPages")}${template}/`;
    let resultPages = await sendCallToAPI(link, store.accessToken);
    if (!resultPages || !Array.isArray(resultPages)) {
      resultPages = [];
    }
    setOptions(resultPages);
    optionsSet.current = new Set(resultPages.map((x) => x.value));
    setValue(resultPages);
    setIsLoading(false);
  };

  useEffect(() => {
    loadOptions();
  }, []);

  const changeOption = (a, b) => {
    const hiddenTabs = options.filter((opt) => !a.some((sel) => sel.value === opt.value));
    dataObject["hiddenTabs"] = hiddenTabs;
    setValue(a);
    changeDataObject(dataObject);
  };
  return (
    <>
      <label>Pages to display:</label>
      <Select isDisabled={disabled} value={value} isMulti isLoading={isLoading} options={options} onChange={(a, b) => changeOption(a, b)} />
    </>
  );
};
const ChooseReportType = ({ show, dataObject, changeDataObject, disabled }) => {
  return (
    <div className="content-block">
      <label>Report type:</label>
      <Select isDisabled={disabled} value={{ label: dataObject["reportType"], value: dataObject["reportType"] }} />
    </div>
  );
};
const ChooseTemplate = ({ show, dataObject, changeDataObject, disabled, errors }) => {
  const [store] = useStore();
  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState([]);

  const loadOptions = async () => {
    const { reportType } = dataObject;
    const link = `${getReportingLinks("getTemplates")}${reportType}/`;
    let resultTemplates = await sendCallToAPI(link, store.accessToken);
    if (!resultTemplates || !Array.isArray(resultTemplates)) {
      resultTemplates = [];
    }
    setOptions(resultTemplates);
    setIsLoading(false);
  };

  useEffect(() => {
    loadOptions();
  }, []);

  const changeOption = (a, b) => {
    dataObject["template"] = a.value;
    changeDataObject(dataObject);
  };

  return (
    <div className="content-block">
      <label>Select template:</label>
      <Select isDisabled={disabled} isLoading={isLoading} options={options} onChange={(a, b) => changeOption(a, b)} />
      <ErrorField value={"template"} errors={errors} />
    </div>
  );
};

const SteppFooter = ({ step, maxStep, setStep, addReport, dataObject }) => {
  const maxStepReached = step === maxStep;
  return (
    <div className="footer">
      <Button style={{backgroundColor: "#3E66FB", borderRadius: "7px"}} disabled={step < +2} onClick={() => setStep(step - 1)}>
        Previous
      </Button>
      &nbsp;
      <Button style={{backgroundColor: "#3E66FB", borderRadius: "7px"}} onClick={() => setStep(step + 1)} disabled={!dataObject["template"]} hidden={maxStepReached}>
        Next
      </Button>
      <Button  style={{backgroundColor: "#3E66FB", borderRadius: "7px"}} hidden={!maxStepReached} onClick={() => addReport()}>
        Create Report
      </Button>
    </div>
  );
};

export const ErrorField = ({ value, errors }) => {
  return errors[value] && <p style={{ color: "red" }}>{errors[value]}</p>;
};
